const products = [
  {
    name: 'Skylark Reads',
    path: '/products/skylark-reads',
    externalUrl: 'https://www.skylarkreads.com',
    tagline: 'Personalized Reading. Real Books. Measurable Progress.',
    description:
      "Skylark Reads is a reading development platform designed to help students build stronger reading skills through personalized assessment, carefully matched physical books, short comprehension quizzes, and continuous progress tracking.",
    audience: [
      'Students receive a clear reading path, personalized books, goals, badges, and achievements.',
      "Teachers monitor reading activity, assessment performance, and progress across their classes.",
      "Parents understand their child's reading level, completed books, and overall reading development.",
      'Schools manage a structured reading program with centralized student, teacher, assessment, and library tools.',
    ],
    benefits: [
      'Determine a student’s current reading level and recommended reading range.',
      'Match each learner with physical books that are challenging without becoming discouraging.',
      'Measure comprehension and reading growth through quizzes, targets, milestones, and reassessments.',
    ],
  },
];

export default products;
